import { useState } from 'react';

export function CopyForLlmButton({ prompt, label = 'Copy for LLM' }: { prompt: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(prompt).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      title="Copy a structured prompt for an AI assistant to action this task"
      className="inline-flex items-center gap-1 text-[11px] font-medium text-violet-600 hover:text-violet-800 border border-violet-200 hover:border-violet-400 rounded px-2 py-0.5 transition-colors"
    >
      <svg width="11" height="11" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
        <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
      </svg>
      {copied ? '✓ Copied' : label}
    </button>
  );
}
